// extracted by mini-css-extract-plugin
export default {"container":"role-perimission_container__o01Av"};